import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {SupplyAccountType} from "../../types/supply-account.type";
import {AccountDialogService} from "../../services/account-dialogs-service.service";
import {AccountsFacadeService} from "../../angular/services/accounts-facade.service";
import {AccountsService} from "../../services/accounts-service.service";

export class DriverAccountDetailedViewCtrl implements IController {

  accountId: string;

  public account: AccountModel;

  private supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;

  constructor(private accountDialogService: AccountDialogService,
              private accountsFacadeService: AccountsFacadeService,
              private triBreadcrumbsService, private accountsService: AccountsService,
              private $mdSidenav,
              private $timeout) {
  }

  $onInit() {
    // Select Account
    this.accountsFacadeService.selectOne(this.accountId)
      .subscribe(account => {
        if (!!account) {
          this.account = angular.copy(account);

          // Update Angularjs Cycle
          this.$timeout(0).then(() => {
          });
        }
      });

    // Subscribe Account
    this.accountsFacadeService.subscribeToChannels();
  }

  $onDestroy() {
    this.accountsFacadeService.unsubscribeFromChannels();
  }

  openEdit(event: Event) {
    this.accountDialogService.editVendorAccount(event, this.account);
  }

  onDeleteAvatar() {
    const accountCopy = angular.copy(this.account);
    accountCopy.avatarUrl = undefined;
    this.accountsService.updateOne(this.accountId, accountCopy)
      .then((account) => {
        this.account = angular.copy(account);
      });
  }

  toggleSidenav() {
    this.$mdSidenav('driverAccountInfo').toggle();
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('driverAccountDetailedView', {
    bindings: {
      accountId: '<'
    },
    template: require('./driver-account-detailed-view.html').default,
    controller: DriverAccountDetailedViewCtrl
  });
